import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useUserStats } from "@/hooks/useUserStats";
import { playDailyTarget } from "@/lib/sounds";

export function DailyTargetBanner() {
  const { data: stats } = useUserStats();
  const [show, setShow] = useState(false);
  const [lastSeen, setLastSeen] = useState<string | null>(null);

  useEffect(() => {
    if (!stats) return;
    const today = new Date().toISOString().split("T")[0];
    const hitTarget = stats.daily_completed >= stats.daily_target && stats.daily_completed_date === today;

    if (hitTarget && lastSeen !== today) {
      setShow(true);
      setLastSeen(today);
      playDailyTarget();
      setTimeout(() => setShow(false), 3000);
    }
  }, [stats, lastSeen]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          className="mb-4 px-4 py-3 rounded-lg bg-primary/10 border border-primary/20 text-center"
        >
          <span className="text-sm font-mono font-bold tracking-wider text-primary">
            DAILY TARGET CLEARED
          </span>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
